import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Form,
  FormControl,
  FormLabel,
  InputGroup,
  Modal,
} from 'react-bootstrap';
import infiniteLoop from "../../../../assets/img/animated-icons/infinite-loop.json";
import {

  faSave,
  faRedo,

  faEraser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { ChangeEvent, ChangeEventHandler, useState } from 'react';
import { AppDispatch, RootState } from '../../template/store';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAsyncDebounce } from 'react-table';
import {  addTruckerDetails, fetchAddressSuggestions2,  getTruckerDetails, updateTruckerDetails } from '../actions/instruction';
import { getCountryList } from '../../registration/actions/Registration';
import { updateSelectedAddressResult } from '../../blRequestInstruction/components/instructionSlice/CarrierHaulageSlice';
import { InstructionList } from '../types';
import React, { useEffect } from 'react';
import {
 
  getBulkfileExtensionList,
  getAllowMultipleCountryList,
  getActiveInactiveList,
} from '../../blRequestInstruction/components/actions/Instruction';

import { AESDecrypt, AESDecryptAny } from '../../../../encrypt-util';
import SoftBadge from '../../../../components/common/SoftBadge';
import {
  faArrowAltCircleLeft,
  faEdit,
} from '@fortawesome/free-regular-svg-icons';

import { commonApproveReject } from '../actions/instruction';

import Lottie from 'lottie-react';
import { clearFields } from '../../blRequestInstruction/components/instructionSlice/AgentNominationSlice';
import { updateDashbaordRefresh } from '../../../common/components/DataTable/slices/DataTable';
import { useBackNavigation } from '../../../../hooks/BackNavigation';
import { isEditable } from '@testing-library/user-event/dist/utils';
import { updateLinerDataCountry } from '../../../common/slices/userDetails';
import { useFormNavigationWarning } from '../../../../hooks/useFormNavigationWarning';
import UnsavedChangesModal from '../../../../components/common/UnsavedChangesModal';
import { setDirty } from '../../formDirtySlice';

const TruckerMaster = () => {


const { master_trucker_id} = useParams();
  const masterTruckerId= AESDecrypt(master_trucker_id);
    const isDirty = useSelector((state:RootState) => state.formDirty.isDirty);

  const [clearable, setClearable] = useState(true);

const[loading,setLoading]=useState(false)
  // const dataCountry = useSelector(
  //   (state: RootState) => state.userProfile.linerDataCountry
  // );
  
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );

    const linerCountryList = useSelector(
      (state:RootState) => state.userProfile.countryList
    );
    
  const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem('@user-selected-datacountry')) || [];
  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;
      const partnerCountry = profileDetails.partnerCountry;
      const linerDataCountry = useSelector(
        (state:RootState) => state.userProfile.linerDataCountry)
      const dataCountry = storedCountry
      ? storedCountry
      : linerDataCountry
      ? linerDataCountry
      : profileDetails.partnerCountry || null;

  const selectedLinerId = useSelector((state: RootState) => state.navbarTop.linerId);

  const linerId =
    profileDetails?.partnerType === 'liner'
      ? profileDetails?.partnerId
      : selectedLinerId;
  const selectedRouter = useSelector(
    (state: RootState) => state.documentHistory.selectedRouter
  );
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();

  const location = useLocation();
  // const docId = getUnprefixedPathname().split('/')[4];

  const navigate = useNavigate();

  const onBack = useBackNavigation();
  const [submitEnable, setSubmitEnable] = useState(false);

 
  const resetForm = () => {
    setLoading(false)
    reset()
  };

  useEffect(() => {
    if(matchPathInstruction()){
      setSubmitEnable(false)
      clearErrors()
dispatch(getTruckerDetails(masterTruckerId)).unwrap()
.then((response: any) => {
console.log("responseee",response)
 setValue("Country", response[0].countryCode);
 setValue("truckerName", response[0].truckerName);
 setValue("truckerID", response[0].truckerId);
 setValue("InternalCode", response[0].internalCode);

})
    }else{
reset()
    }

  }, [masterTruckerId]);






  const matchPathInstruction = () =>
    matchPath(
      {
        path: "/truckMasterDashboard/truckMaster/:master_trucker_id",
        caseSensitive: true,
        end: true,
      },
      location.pathname
    ) 
    
  const _onCloseForm = () => {
    setLoading(false)
  navigate('/truckMasterDashboard')
  };

  type FormValues = {
    Country: string;
    truckerName: string;
    truckerID: string;
    InternalCode: string;

    
  };

  const validationSchema = Yup.object().shape({
  
    truckerID: Yup.string().required(
      t('resource_3:isRequired', { field:t("resource_2:trucker_id") })
    ),
    truckerName: Yup.string().required(
      t('resource_3:isRequired', { field: t("resource_2:truckerName") })
    ),
    InternalCode: Yup.string().required(
      t('resource_3:isRequired', { field:   t("resource_2:internal_code")})
    ),
   
    
      
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { errors, touchedFields },
    watch,
    clearErrors,
    setError
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      Country: "", // Default value for Country
    },
   
    mode: 'onChange',
  });
    const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
  isChanged: isDirty,
  isEditable: true,
  onConfirm:  onBack // or onBack, or your navigation function
});
  
    const handleStayOnPage = () => {
      handleCancel();
    };
  
  

    const handleLeavePage = () => {
    //  onBack()
         const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
    navigate(`${APP_PATH_PREFIX}/truckMasterDashboard`)
    };
  const onSubmit = handleSubmit(

    async (payload: any) => {
      console.log("idhere")
      try {

        // toast.dark(t('resource_2:successfullyCreated'));
        const payloadData={
          "countryCode": payload.Country,
          "scacCode":payload.truckerID,
          "bicCode":payload.truckerName.toUpperCase(),
          "truckerId":payload.truckerID,
          "truckerName":payload.truckerName,
          "internalCode":payload.InternalCode,
          "linerId": linerId
        }
        var payloadNew
        matchPathInstruction()?
         payloadNew={
          ...payloadData,
          masterTruckerId
        }:  payloadNew={
          ...payloadData
         
        }
        !matchPathInstruction()?
        dispatch(addTruckerDetails(payloadNew))  .unwrap()
        .then((response: any) => {
          if(response.status)
          setLoading(true)
          console.log("payloaddd",response?.responseMsg)
          toast.success(response?.responseMsg);
        if(  Object.keys(response).length > 0) {
          setTimeout(() => {
            _onCloseForm() 
            setTimeout(() => {
              dispatch(updateDashbaordRefresh(true));
            }, 2000);
          }, 500);}
        }):
        dispatch(updateTruckerDetails(payloadNew))  .unwrap()
        .then((response: any) => {
          if(response.status)
          setLoading(true)
          console.log("payloaddd",response?.responseMsg)
          toast.success(response?.responseMsg);
        if(  Object.keys(response).length > 0) {
          setTimeout(() => {
            _onCloseForm() 
            setTimeout(() => {
              dispatch(updateDashbaordRefresh(true));
            }, 2000);
          }, 500);}
        })
     
      } catch (err: any) {
        console.error(err.message);
        setLoading(false)
      }
    }

  );


  useEffect(() => {
    if (dataCountry ||  !matchPathInstruction() ) {
      // Set the country value once the dataCountry is available
      setValue("Country", dataCountry, { shouldValidate: true });
    }
  }, [dataCountry, setValue,location.pathname]);








  return (
    <Card style={{ height: '100%',overflow:'auto' }}>
       <UnsavedChangesModal
              show={showModal}
              onHide={handleStayOnPage}
              onConfirm={handleLeavePage}
            />
      <Card.Header className='border-bottom d-flex justify-content-between align-items-center'>
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className='text-warning cursor-pointer fa-lg mb-1'
         // onClick={_onCloseForm}
      onClick={handleBack}
        />
 
          <div className='row col-12'>
            <div className='col-lg-4'>
              <h2 className='fs-0 text-primary'>
                {' '}
                {t("resource_2:trucker_Details")}
              </h2>
            </div>
          </div>
      
 
      </Card.Header>

      <Card.Body>
        <div className='container'>
        
          <Form onSubmit={onSubmit} autoComplete='off'>
            <div className='row'>
              <div className='col-lg-12'>
        
            
      

                <div className='row'>
                  <div className='col-lg-6 '>
                    <Form.Group controlId='truck.Country'>
                    <span className='mandatory'>*</span>
                      <Form.Label>   {t("resource_1:country")}</Form.Label>
                      <div className='row'>
                        <div className='col-lg-12 mb-1'>
                        <Form.Select
                    {...register("Country")}
                    onChange={(e: any) => {
                      dispatch(setDirty())
                      setValue("Country", e.target.value,{ shouldValidate: true } );
                      clearErrors("Country");
                    }}
                    value={watch('Country')}
                    disabled={      matchPathInstruction()&& !submitEnable?true:false}
                    className={`fs--1 ${errors?.Country ? "is-invalid" : ""
                      }`}
                  >
        {
linerCountryList.map((option: any) => (
                                      <option
                                        key={option.countryCode}
                                        value={option.countryCode}
                                      >
                                        {option.countryName}
                                      </option>
                                    ))
                                  }
          
                    
                  </Form.Select>
                          <div className='invalid-feedback'>
                            {errors.Country?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>
                    </Form.Group>
                  </div>
                  <div className='col-lg-6 '>
                    <Form.Group controlId='truck.name'>
                    <span className='mandatory'>*</span>
                      <Form.Label>
                        {/* <span className='mandatory'>*</span> */}
                        {t("resource_2:truckerName")}
                      </Form.Label>
                      <div className='row'>
                        <div className='col-lg-12 mb-1'>
                          <Form.Control
                            size='sm'
                            {...register('truckerName')}
                            className={`fs--1 form-control ${
                              errors.truckerID ? 'is-invalid' : ''
                            }`}
                            type='text'
                            onChange={(e) =>
                            {
                              setValue(
                                'truckerName',
                                e.target.value,{ shouldValidate: true ,shouldDirty:true}
                              )
                                    dispatch(setDirty())
                              clearErrors("truckerName");
                            }
                            }
                            value={watch('truckerName')}
                 disabled={      matchPathInstruction()&& !submitEnable?true:false}

           
                            
                          />
                          <div className='invalid-feedback'>
                            {errors.truckerName?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>
                    </Form.Group>
                  </div>
                  <div className='col-lg-6 '>
                    <Form.Group controlId='truck.truckid'>
                    <span className='mandatory'>*</span>
                      <Form.Label>
                        {/* <span className='mandatory'>*</span> */}
                        {t("resource_2:trucker_id")}
                      </Form.Label>
                      <div className='row'>
                        <div className='col-lg-12 mb-1'>
                          <Form.Control
                            size='sm'
                            {...register('truckerID')}
                            className={`fs--1 form-control ${
                              errors.truckerID ? 'is-invalid' : ''
                            }`}
                            type='text'
                            onChange={(e) =>
                            {
                              setValue(
                                'truckerID',
                                e.target.value.trim().toLocaleUpperCase(),{ shouldValidate: true ,shouldDirty:true}
                              )
                                    dispatch(setDirty())
                              clearErrors("truckerID");
                            }
                            }
                            value={watch('truckerID')}
                 disabled={      matchPathInstruction()&& !submitEnable?true:false}

           
                            
                          />
                          <div className='invalid-feedback'>
                            {errors.truckerID?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>
                    </Form.Group>
                  </div>

                  <div className='col-lg-6'>
                    <Form.Group controlId='truck.code'>
                    <span className='mandatory'>*</span>
                      <Form.Label>
                        {/* <span className='mandatory'>*</span> */}
                       {t("resource_2:internal_code")}
                      </Form.Label>
                      <div className='row'>
                        <div className='col-lg-12 mb-1'>
                        <Form.Control
                            size='sm'
                            {...register('InternalCode')}
                            className={`fs--1 form-control ${
                              errors.InternalCode ? 'is-invalid' : ''
                            }`}
                            type='text'
                            onChange={(e) =>
                            {
                              setValue(
                                'InternalCode',
                                e.target.value.trim().toLocaleUpperCase(),{ shouldValidate: true,shouldDirty:true }
                              )
                                    dispatch(setDirty())
                              clearErrors("InternalCode");
                            }
                            }
                            value={watch('InternalCode')}
                 disabled={      matchPathInstruction()&& !submitEnable?true:false}

           
                            
                          />
                          <div className='invalid-feedback'>
                            {errors.InternalCode?.message?.toString()}
                          </div>
                        </div>
                 
                      </div>
                    </Form.Group>
                  </div>


              


          

        
           
       
    
          
            {/*   <div className='col-lg-6 mb-3'>
                <Form.Group
                 
                  controlId='bulk.allow'>
                  <Form.Label>

            
                    {t("resource_3:allow_multiple_country")}
                  </Form.Label>
                  <Form.Select
                    {...register("allowMultipleCountry")}
                    onChange={(e: any) => {
                      setValue("allowMultipleCountry", e.target.value,{ shouldValidate: true } );
                      clearErrors("allowMultipleCountry");
                    }}
                    value={
                      watch("allowMultipleCountry")
                    }
                    disabled={      matchPathInstruction()&& !submitEnable?true:false}
                    className={`fs--1 ${errors?.bulkfileExtension ? "is-invalid" : ""
                      }`}
                  >
        {
allowMultipleCountryList.map((option: any) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.text}
                                      </option>
                                    ))
                                  }
          
                    
                  </Form.Select>
                  <div className='invalid-feedback'>
                    {errors.allowMultipleCountry?.message?.toString()}
                  </div>

            
                </Form.Group>
              </div> */}
        
        
        

                    <div className='col-lg-8 offset-lg-2 mt-2 d-flex justify-content-center align-items-center'>
                    {  !matchPathInstruction()  || submitEnable == true? (    
                      <>    <Button
                      variant='falcon-primary me-2'
                      size='sm'
                   
                      type='submit'
                      disabled={loading}
                  >
                      <FontAwesomeIcon icon={faSave} className='me-2' />
                      {t('resource_1:submit')}
                    </Button>
       
                    {/*  !matchPathInstruction() */ true &&(
                            <Button
                        variant='falcon-danger'
                        onClick={() => {
                     
                          resetForm();
                          setLoading(false)
                         
                       
                        }}
                        size='sm'>
                        <FontAwesomeIcon icon={faRedo} className='me-2' />
                        {t('resource_1:reset')}
                      </Button> )}
                      
                      {/*  {submitEnable == true && matchPathInstruction() && 
                      <Button    onClick={() =>{setSubmitEnable(false);         setLoading(false);clearErrors(); reset()}}  variant='falcon-danger' size='sm'>
                              <FontAwesomeIcon icon={faEraser} className="me-2" />
                                            {t("resource_1:clear")}
                                          </Button>} */}
                      </>
                   ):""} 
      {  matchPathInstruction() && submitEnable == false ? (<Button
                        variant="falcon-primary"
                        size="sm"
                        className="me-2"
                     onClick={() => setSubmitEnable(true)}
                      
                        
                      >
                        
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        {t("resource_1:edit")}
                      </Button>):""}
                
                    </div>
        
       
            </div>
            </div>
            </div>
          </Form>
     
        </div>
      </Card.Body>
    </Card>
  );
};

export default TruckerMaster;

